module.exports = __webpack_public_path__ + "img/guadeloupe.0211f172.svg";